export const MARKET_OVERVIEW = 'market_overview'
export const MARKET_OVERVIEW_EMPTY_STATE = 'market_overview_empty_state'
export const RENTAL_POTENTIAL = 'rental_potential'
export const AFFORDABILITY = 'affordability'
export const BUYING_TIMELINE = 'buying_timeline'

export const HOME_ESTIMATE = 'home_estimate'
export const HOME_ESTIMATE_EMPTY_STATE = 'home_estimate_empty_state'
export const IMPORTANT_NOW = 'important_now'
export const CUSTOM_MODULE = 'custom_module'
export const MANAGE_LOANS_EMPTY_STATE = 'manage_loans_empty_state'
export const PRINCIPAL_INTEREST = 'principal_interest'
export const MORTGAGE_INSURANCE = 'mortgage_insurance'
export const HOME_INSURANCE = 'home_insurance'
export const REVERSE_MORTGAGE = 'reverse_mortgage'
export const REFINANCE_OPTIONS = 'refinance_options'
export const PURCHASING_POWER = 'purchasing_power'
export const EQUITY_CASH_OUT = 'equity_cash_out'
